import RouteBuilder from 'arbitrip-common/general/utils/RouteBuilder';
import { HOTEL_SEARCH_URL_FIELDS } from 'arbitrip-common/general/constants';
import ResultsStore from '../stores/ResultsStore';
import ProfileStore from '../stores/ProfileStore';
import { isElalCompany } from './isCompany';

/**
 * Merges URL params from stores into search_terms before building routes.
 * Add new store-driven params here as needed (e.g. use_max_points from ResultsStore).
 */
function mergeStoreParamsIntoSearchTerms(search_terms) {
	const useMaxPoints = ResultsStore.getShowPricesInPoints();
	return useMaxPoints ? { ...search_terms, use_max_points: true } : search_terms;
}

function withSamlVerified(route) {
	const profile = ProfileStore.getProfile();
	if (!isElalCompany() || profile.anonymous) return route;
	const [path, query] = route.split('?');
	const params = new URLSearchParams(query);
	params.set('saml_verified', '1');
	return `${path}?${params.toString()}`;
}

export default {
	buildSearchRoute: (search_terms) => withSamlVerified(RouteBuilder.buildSearchRoute(search_terms)),
	goToSearchPage: (navigate, search_terms) => navigate(withSamlVerified(RouteBuilder.buildSearchRoute(search_terms))),

	buildResultsRoute: (search_terms, search_token) =>
		withSamlVerified(RouteBuilder.buildResultsRoute(mergeStoreParamsIntoSearchTerms(search_terms), search_token)),
	goToResultsPage: (navigate, search_terms, search_token) =>
		navigate(withSamlVerified(RouteBuilder.buildResultsRoute(mergeStoreParamsIntoSearchTerms(search_terms), search_token))),

	buildHotelRoute: (hotel, search_token, search_terms) =>
		RouteBuilder.buildHotelRoute(hotel, search_token, mergeStoreParamsIntoSearchTerms(search_terms)),
	goToHotelPage: (navigate, hotel, search_token, search_terms) =>
		navigate(RouteBuilder.buildHotelRoute(hotel, search_token, mergeStoreParamsIntoSearchTerms(search_terms))),
	buildHotelSearchURL: (hotel, search_terms) =>
		window.location.origin + RouteBuilder.buildHotelRoute(hotel, null, mergeStoreParamsIntoSearchTerms(search_terms), HOTEL_SEARCH_URL_FIELDS),

	buildReservationRoute: RouteBuilder.buildReservationRoute,
	goToReservationPage: (navigate) => navigate(RouteBuilder.buildReservationRoute()),

	buildTripsRoute: RouteBuilder.buildTripsRoute,
	goToTripPage: (navigate, tripId) => navigate(RouteBuilder.buildTripRoute(tripId)),
	goToTripsPage: (navigate) => navigate(RouteBuilder.buildTripsRoute()),

	// // refresh: () => window.location.reload(),
	// refresh: () => history.go(0)
};
